import { dateNow } from '../../tools/timeUtils';
var simulation;
export function initSimulation(simulationStart, simulationEnd, simulationLabel) {
    if (simulationStart && simulationEnd && simulationLabel) {
        simulation = {
            start: new Date(simulationStart).getTime(),
            end: new Date(simulationEnd).getTime(),
            label: simulationLabel,
        };
    }
}
export function isSimulationActive() {
    var now = dateNow();
    return simulation !== undefined && now >= simulation.start && now <= simulation.end;
}
export function getSimulationLabel() {
    return simulation === null || simulation === void 0 ? void 0 : simulation.label;
}
